import api from "services/api";

import { IInspectionListItem, IInspectionReportResponse, IInspectionResponse, ISummary } from "./raio-x.types";

/** Rotas do F0 (PR #1989). Corpo direto, sem envelope `{ data }` (mesmo padrão de operational-panel.service.ts). */
export async function runInspection(buyerOrganizationId: string): Promise<{ id: string; summary: ISummary }> {
  const { data } = await api.post<{ id: string; summary: ISummary }>(`/v2/organizations/${buyerOrganizationId}/configuration-inspections`);
  return data;
}

export async function listInspections(buyerOrganizationId: string): Promise<IInspectionListItem[]> {
  const { data } = await api.get<IInspectionListItem[]>(`/v2/organizations/${buyerOrganizationId}/configuration-inspections`);
  return data;
}

export async function getInspection(id: string): Promise<IInspectionResponse> {
  const { data } = await api.get<IInspectionResponse>(`/v2/configuration-inspections/${id}`);
  return data;
}

/** why: relatório da última inspeção persistida; a tela manda sempre um id só, mas o backend aceita lista. */
export async function fetchInspectionReport(buyerOrganizationIds: string[]): Promise<IInspectionReportResponse> {
  const { data } = await api.post<IInspectionReportResponse>("/v2/configuration-inspections/report", { buyerOrganizationIds });
  return data;
}
